export const QUESTION_CHILD_KEYS = [
  "questions",
  "subItems",
  "subItems2",
  "subItems3",
  "options",
];

export function getValueByPath(source, path) {
  if (!source || !path) return undefined;

  return String(path)
    .split(".")
    .reduce((value, key) => (value ? value[key] : undefined), source);
}

export function walkQuestionTree(node, callback, inheritedSection) {
  if (!node) return;

  const section = node.section || inheritedSection;
  callback(node, section);

  QUESTION_CHILD_KEYS.forEach((childKey) => {
    if (Array.isArray(node[childKey])) {
      node[childKey].forEach((childNode) => {
        walkQuestionTree(childNode, callback, section);
      });
    }
  });
}
